import c from 'classnames';
import React, { FC } from 'react';
import './PageAction.css';
import { PageAction } from 'vrlcm-gui-types';

interface Props {
  action: PageAction;
  hovered: boolean;
  solidOnHover: boolean;
  solid: boolean;
}

export const PageActionIcon: FC<Props> = props => {
  const { action, hovered, solidOnHover, solid } = props;
  if (action.icon.indexOf('images/') !== -1) {
    return (
      <img
        src={action.icon}
        className="page-action-item-icon"
        alt={action.name}
        height="36"
        width="36"
      />
    );
  } else {
    return (
      <clr-icon
        shape={action.icon}
        size="36"
        class={c('page-action-item-icon', {
          'is-solid': solid || (solidOnHover && hovered)
        })}
        title={action.name}
        aria-hidden="true"
      />
    );
  }
};
